import { render, staticRenderFns } from "./train_edit.vue?vue&type=template&id=0bd1d330&"
import script from "./train_edit.vue?vue&type=script&lang=ts&"
export * from "./train_edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports